import React, { useEffect, useState } from "react"
import { Field } from "formik";
import AsyncSelect from "react-select/async"
import styled from "styled-components"
import { apiVocByCritere } from "../api";

const Formulaire = styled.div`
background-color: darkgrey;
border: 2px solid #e2702c;
float:left;
`

const Champ = styled.div`
margin:0px auto;
padding: 10px;
float:left;
width:80%;
`

const Meta = styled.div`
padding: 10px 0px;
width:100%;
`
const Lieu = styled.div`
background-color: lightgrey;
float:left;
margin: 15px;
padding: 10px;
width:80%;
`

const Label = styled.div`
min-width: 250px;
`

const Note = styled.div`
padding: 5px;
text-align: justify;
width: 80%;
min-width:500px;
`


const Lieux = styled(AsyncSelect)`
margin: 10px;
max-width: 500px;
display: block;
`

//support avec uri et label
const construitOptionOpentheso = (element) => {
  //console.log(element)
  const retour = {
    value: {
      uri: element.uri,
      label: element.label
    },
    label: element.label
  }
  return retour
}

const valeurs = (tableau) => {
  console.log(tableau)
  if ( ! tableau) {
    return []
  }
  return (tableau.map(element => construitOptionOpentheso(element)))
}

const creeLieux = (valeurChaine) => {
  //console.log("Initialisation")
  //console.log(valeurChaine)
  if ( typeof valeurChaine === "object"  || valeurChaine === undefined) {
    return []
  }
  return(JSON.parse(valeurChaine))
}


const getLabel = (nom) => {
  switch (nom){
    case 'lieu_origine':
      return 'Lieu d\'origine'
      case 'lieu_conservation':
        return 'Lieu de conservation'
    default:
      return '!! Inconnu !!'
  }
}

const elemHtml = (html) => {
  const htmlFormate = (typeof html === 'string')? html.replace(/\n/g, "<br/>") : ""
  return {__html: htmlFormate}
}

//Champ texte avec le critere de recherche
//champ div avec la référence visuelle
//les états dépendent du nom
// mesLieuxOpentheso[$nom], maValeurOpentheso[$nom]
// commentaire[$nom]
const ElementFormOpenthesoAvecChamps = (params) => {

  const {nom, initialValues, handleChange} = params
  const champCommentaire = `commentaire_${nom}`
  //console.log(initialValues)

  const [mesLieux, setMesLieux ] = useState(creeLieux(initialValues))
  const [monLieu, setMonLieu] = useState({})
  const [commentaireLieu, setCommentaireLieu] = useState("")
  //console.log(mesLieux)

  useEffect(()=>{

  },[mesLieux, monLieu, commentaireLieu ])

  const handleModifierLieu = (event) => {
    //parcours du tableau et suppression
    //console.log("Lieu à modifier")
    const uri = event.target.value

    //console.log(uri)
    let lieuAModifier = {}
    for(const lieuCourant of mesLieux){
      if (lieuCourant.uri === uri){
        lieuAModifier = lieuCourant
         break
      }
    }
    //console.log(lieuAModifier)

    setMonLieu(
      {
        uri: lieuAModifier.uri,
        label: lieuAModifier.label
      }
    )
    setCommentaireLieu(lieuAModifier.commentaire)
   }

   const handleSupprimerLieu = (event) => {
    const uri = event.target.value
    let nouveauLieux = []
    for(const lieuCourant of mesLieux){
      if (lieuCourant.uri === uri){
        continue
      } else {
        nouveauLieux.push(lieuCourant)
      }
    }
    setMesLieux(nouveauLieux)
    handleChange(nouveauLieux)
   }


  const afficheLieu = (lieu) => {
    const refUniqueLieu = lieu.uri.substring(lieu.uri.lastIndexOf("/"))
    return (<Meta key={`lieu_${refUniqueLieu}`}>
      <a key={refUniqueLieu} href={lieu.uri} target= "_blank" rel="noreferrer noopener">{lieu.label}</a>
      {lieu.commentaire && <><Note key={`commentaire_lieu_${refUniqueLieu}`} dangerouslySetInnerHTML={elemHtml(lieu.commentaire)}></Note></>}
        <button type="button" onClick={handleModifierLieu} value={lieu.uri}>Modifier</button>
        <button type="button" onClick={handleSupprimerLieu} value={lieu.uri}>Supprimer</button>
      </Meta>)
  }

  const afficheLieuxDebut = () => {
    const aAfficher = <>
      <Meta>{getLabel(nom)}</Meta>
      {mesLieux.map( lieu => afficheLieu(lieu))}
    </>
    return aAfficher
  }


  const loadOptions = async (critere, callback) => {
    //console.log(critere )
    const numThesaurus = 4
    const groupe = "MT98"
    const retour = await apiVocByCritere(critere, numThesaurus, groupe)
    let mesOptions = []
    mesOptions = valeurs(retour.reponse)
    callback(mesOptions)
   }

  const handleChangeMonLieu = (monOption) => {
    setMonLieu(monOption.value)
  }

  const handleChangeCommentaire = (event) => {
    setCommentaireLieu(event.target.value)
  }

  const handleClick = () => {

    //cas du submit sans saisie
    if ( ! monLieu.uri || typeof monLieu.uri !== 'string'){
      return
    }

    const tempo = {}
    tempo.uri = monLieu.uri
    tempo.label = monLieu.label
    tempo.commentaire = commentaireLieu

    let nouveauxLieu = []
    let trouve = false
    for(const lieuCourant of mesLieux){
      if (lieuCourant.uri === tempo.uri){
        //modification
        nouveauxLieu.push(tempo)
        trouve = true
      } else {
        nouveauxLieu.push(lieuCourant)
      }
    }
    if (! trouve){
      nouveauxLieu.push(tempo)
    }

    setMesLieux(nouveauxLieu)
    //console.log(nouveauxLieu)

    //réinitialisation des états
    setMonLieu({})
    setCommentaireLieu("")

    handleChange(nouveauxLieu)
  }

  //creation de l'element select multiple
  return (
    <Lieu id="lieux">
     {afficheLieuxDebut()}
     <Formulaire>
      <Champ>
        <Label>{getLabel(nom)}</Label>
        <Lieux
          name={nom}
          value={construitOptionOpentheso(monLieu)}
          defaultValue={construitOptionOpentheso(monLieu)}
          placeholder={"Tomponymes Modernes"}
          onChange={handleChangeMonLieu}
          loadOptions={loadOptions}
        />
      </Champ>
      <Champ>
        <Label>Commentaire</Label>
        <Field
          name={champCommentaire}
          as="textarea"
          className="form-control"
          onChange={handleChangeCommentaire}
          value={commentaireLieu}
          rows="2"
          cols="60" />
      </Champ>
      <Champ>
            <button type="button" onClick={handleClick}>Valider</button>
            <br/><i>(ne pas oublier de modifier l'inscription si nécessaire)</i>
      </Champ>
    </Formulaire>
    </Lieu>
  )

}
export default ElementFormOpenthesoAvecChamps